import { createSelector } from 'reselect'
import { State } from 'interfaces/state'
import { ViewportMatchName, ViewportSegment } from 'interfaces/viewport'
import { compareViewports } from 'helpers/viewportHelpers'

export const currentViewportSelector = (state: State): ViewportMatchName | null =>
  state.app.viewport.viewport

export const isMobileSelector = createSelector(
  currentViewportSelector,
  (viewport) =>
    !viewport || compareViewports(viewport, '<', 'w768'),
)

export const isMobileOrTabletSelector = createSelector(
  currentViewportSelector,
  (viewport) => !viewport || compareViewports(viewport, '<=', 'w768'),
)

export const isDesktopSelector = createSelector(
  currentViewportSelector,
  (viewport) =>
    !viewport || compareViewports(viewport, '>=', 'w1024'),
)

export const viewportSegmentSelector = createSelector(
  currentViewportSelector,
  (viewport): ViewportSegment => {
    if (compareViewports(viewport, '<', 'w415')) {
      return 'palm-mobile'
    }

    if (compareViewports(viewport, '<', 'w768')) {
      return 'mobile'
    }

    if (compareViewports(viewport, '<=', 'w768')) {
      return 'tablet'
    }

    return 'desktop'
  }
)

export const isFullscreenEnabledSelector = (state: State): boolean =>
  state.app.viewport.isFullscreenEnabled
